import { render, staticRenderFns } from "./noticeDig.vue?vue&type=template&id=0b340200&scoped=true"
import script from "./noticeDig.vue?vue&type=script&lang=js"
export * from "./noticeDig.vue?vue&type=script&lang=js"
import style0 from "./noticeDig.vue?vue&type=style&index=0&id=0b340200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b340200",
  null
  
)

export default component.exports